import React from "react";

export const DesktopIcon = (): JSX.Element => {
    return (
        <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.75 0.75H2.75C1.64543 0.75 0.75 1.64543 0.75 2.75V12.75C0.75 13.8546 1.64543 14.75 2.75 14.75H20.75C21.8546 14.75 22.75 13.8546 22.75 12.75V2.75C22.75 1.64543 21.8546 0.75 20.75 0.75Z"
                stroke="#C41796"
                strokeWidth="1.5"
            />
            <path d="M11.75 14.75V18.75" stroke="#C41796" strokeWidth="1.5" />
            <path d="M7.75 18.75H15.75" stroke="#C41796" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};
